exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "\n.sortable-chosen, .sortable-ghost {\n  background: none !important;\n  background-color: transparent !important;\n  max-width: 100% !important;\n  min-width: 50% !important;\n  content: '';\n  opacity: 0.5 !important;\n  transition: all .2s !important;\n}\n.list-complete-enter, .list-complete-leave-active {\n  background: red;\n}\n.chart-item {\n  margin-bottom: 50px;\n}\n.style-chooser {\n  width: 13vw;\n  float: left;\n  margin-right: 15px;\n}\n.style-chooser .vs__dropdown-toggle {\n  appearance: none;\n  display: -ms-flexbox;\n  display: flex;\n  padding: 0 0 4px;\n  background: none;\n  border: 1px solid rgba(60, 60, 60, 0.26);\n  border-radius: 4px;\n  white-space: normal;\n  background: white;\n}\n.col-per-83 {\n  width: 83%;\n}\n.col-per-17 {\n  width: 17%;\n}\n.col-per-100 {\n  width: 100%;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-compiler?{"id":"data-v-632aab56","scoped":false,"hasInlineConfig":false}!./~/sass-loader/lib/loader.js!./~/vue-loader/lib/selector.js?type=styles&index=0!./client/components/dashboard/Dashboard.vue
// module id = 1024
// module chunks = 0